export default __webpack_public_path__ + "static/media/UniversityCMG.c408bbf1.webp";